import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LexoraLanding from "./components/LexoraLanding";
import TeacherPortal from "./components/teacher/TeacherPortal";
import BookingApp from "./components/booking/BookingApp";
import AboutPage from "./components/pages/AboutPage";
import MethodPage from "./components/pages/MethodPage";
import InstructorsPage from "./components/pages/InstructorsPage";
import SuccessPage from "./components/pages/SuccessPage";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import TermsOfService from "./components/pages/TermsOfService";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";
import analytics from "./lib/analytics";
import Header from "./components/header/Header";

function App() {
  useEffect(() => {
    // Initialize analytics
    if (analytics.checkConsent()) {
      analytics.enable();
    }

    // Add Plausible analytics script if enabled
    const plausibleDomain = process.env.REACT_APP_PLAUSIBLE_DOMAIN;
    if (plausibleDomain && analytics.checkConsent()) {
      const script = document.createElement('script');
      script.defer = true;
      script.setAttribute('data-domain', plausibleDomain);
      script.src = 'https://plausible.io/js/script.js';
      document.head.appendChild(script);
    }

    // Track initial page view
    analytics.trackPageView(window.location.pathname);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <div className="min-h-screen flex flex-col">
          <main className="flex-1">
            <Header />
            <Routes>
              <Route path="/" element={<LexoraLanding />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/method" element={<MethodPage />} />
              <Route path="/instructors" element={<InstructorsPage />} />
              <Route path="/success" element={<SuccessPage />} />
              <Route path="/success-stories" element={<SuccessPage />} />
              <Route path="/teacher" element={<TeacherPortal />} />
              <Route path="/app" element={<BookingApp />} />
              <Route path="/booking" element={<BookingApp />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;